import { Users } from './users';

export default Users;
